import { Tooltip } from "./tooltip";
import { Element } from "../element/element";
import { Modal } from "./modal";
import { OrganizationChart } from "./organizationChart";
import { Popover } from "./popover";
import { Spinner } from "./spinner";
import { Sidenav } from "./sidenav";
import { Dropdown } from "./dropdown";
import { MultiCarousel } from "./multiCarousel";
import { Treeview } from "./treeview";
import { Collapse } from "./collapse";
import { Carousel } from "./carousel";
import { Tabs } from "./tabs";
import { Toast } from "./toast";
import { Whatsapp } from "./whatsapp";
var componentMap = {
    carousel: Carousel,
    collapse: Collapse,
    element: Element,
    dropdown: Dropdown,
    modal: Modal,
    multiCarousel: MultiCarousel,
    organizationChart: OrganizationChart,
    popover: Popover,
    tooltip: Tooltip,
    sidenav: Sidenav,
    spinner: Spinner,
    treeview: Treeview,
    tabs: Tabs,
    toast: Toast,
    whatsapp: Whatsapp
};
export var components = Object.fromEntries(Object.entries(componentMap).map(function (_a) {
    var name = _a[0], classInstance = _a[1];
    return [name, function (args) { return new classInstance(args); }];
}));
